<template>
  <v-dialog
    v-model="show"
    max-width="440px"
    @click:outside="cancel"
  >
    <v-card class="pa-sm-8 pa-4">
      <v-card-title class="text-h6 pa-0 mb-1">
        Роль сотрудника
      </v-card-title>
      <v-card-subtitle class="pa-0 mb-6">
        {{ userName }}
      </v-card-subtitle>

      <v-card-text class="pa-0">
        <v-select
          v-model="selected"
          :items="rolesDropdown"
          :rules="[rules.required]"
          outlined
          dense
          hide-details="auto"
          label="Роль"
        ></v-select>

        <p class="text--secondary text-sm mt-4 mb-0">
          Права сотрудника берутся из роли. Что именно она открывает, видно в разделе «Роли».
        </p>
      </v-card-text>

      <v-card-actions class="pa-0 mt-6">
        <v-spacer></v-spacer>
        <v-btn
          color="secondary"
          outlined
          @click="cancel"
        >
          Отмена
        </v-btn>
        <v-btn
          color="primary"
          :disabled="!selected || selected === role"
          :loading="saving"
          @click="save"
        >
          Сохранить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { rules } from '@/helpers/validation'

export default {
  name: 'UserRoleDialog',
  props: {
    show: { type: Boolean, default: false },
    userId: { type: Number, default: 0 },
    userName: { type: String, default: '' },
    role: { type: String, default: '' },
    cancellation: { type: Function, required: true },
  },
  data: () => ({
    rules,
    selected: '',
    saving: false,
  }),
  computed: {
    ...mapGetters('dictionary', { rolesDropdown: 'rolesDropdown' }),
  },
  watch: {
    show(opened) {
      if (opened) this.selected = this.role
    },
  },
  async mounted() {
    await this.fetchRoles()
  },
  methods: {
    ...mapActions('user', { updateRole: 'updateRole' }),
    ...mapActions('dictionary', { fetchRoles: 'fetchRoles' }),
    async save() {
      this.saving = true
      try {
        await this.updateRole({ id: this.userId, role: this.selected })
        this.cancellation()
      } finally {
        this.saving = false
      }
    },
    cancel() {
      this.cancellation()
    },
  },
}
</script>
